import type { GoOfflineController } from "../types";

export function createController(
  registration: ServiceWorkerRegistration | null,
  cleanup: () => void
): GoOfflineController {
  return {
    isOnline() {
      return typeof navigator === "undefined" ? true : navigator.onLine;
    },
    getRegistration() {
      return registration;
    },
    async update() {
      await registration?.update();
    },
    async unregister() {
      if (!registration) {
        return false;
      }

      return registration.unregister();
    },
    destroy() {
      cleanup();
    }
  };
}
